<mat-card>
    
    <mat-card-header>
        <mat-card-title>Gestión de Publicación</mat-card-title>
        <mat-card-subtitle></mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>

        <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
        <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
        <mat-label *ngIf="!isSearching && msgError?.length > 0">{{msgError}}</mat-label>

        <div *ngIf="!isSearching && item != null">

            <!--Puede editar-->
            <ng-container *ngIf="canEdit || canAdd">

                <form [formGroup]="formGroup">

                    <!--Info General Edit-->
                    <mat-expansion-panel [expanded]="true">

                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon style="margin-top: -3px; margin-right: 5px;">settings</mat-icon> Configuraciones de Publicación
                            </mat-panel-title>
                            <mat-panel-descripcion>
                            </mat-panel-descripcion>
                        </mat-expansion-panel-header>

                        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center" style="margin-bottom: 10px">

                            <!--Carga de imágen-->
                            <div fxLayout="column" fxLayout.xs="column">
                                <div fxFlex=100 fxFlex.xs=100 class="flex-item" align="Center" *ngIf="!imagenPortadaImageChanged()">
                                    <a target="_blank" href="{{item?.ImagenPortadaUrl}}">
                                        <img src="{{item?.ImagenPortadaUrl}}" style="height: 100px; width: 100px; border-radius: 100%;">
                                    </a>
                                </div>
                                <div fxFlex=100 fxFlex.xs=100 class="flex-item" align="Center" *ngIf="imagenPortadaImageChanged()">
                                    <img src="{{imagenPortadaImageBase64}}"
                                    style="height: 100px; width: 100px; border-radius: 100%; margin-bottom: 10px;">
                                </div>
                                <div fxFlex=100 fxFlex.xs=100 class="flex-item" align="Center">
                                    <button type="button" mat-raised-button [disabled]="isProcessing()" (click)="fileInput.click()">Cambiar Portada</button>
                                    <input hidden type="file" (change)="convertFileToBase64($event)" accept="image/*" #fileInput color="primary">
                                </div>
                            </div>

                        </div> 
                        
                        <div fxLayout="row stretch" fxLayout.xs="column">

                            <!--Selector de Comunidad-->
                            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                                <mat-form-field appearance="outline" style="width: 100%">
                                    <mat-label>{{'Comunidad' | translate}}</mat-label>
                                    <mat-select formControlName="ComunidadId">
                                        <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="!formGroup.controls['ComunidadId'].valid && formGroup.controls['ComunidadId'].touched">
                                        {{ getErrorComunidad() }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex=50 fxFlex.xs=100 class="flex-item" fxLayoutAlign="center" style="margin-top: 15px;">
                                <mat-checkbox formControlName="NotificarUsuarios" (keyup.enter)="onGuardar()" color="primary">Notificar usuarios de los cambios de la publicación</mat-checkbox> 
                            </div>

                        </div>

                    </mat-expansion-panel>

                    <br/>

                    <!--Sección Título-->
                    <mat-expansion-panel [expanded]="true" hideToggle="true">

                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon style="margin-right: 5px;">title</mat-icon> <p style="margin-top: 3px;">Título</p>
                            </mat-panel-title>
                            <mat-panel-description>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div fxLayout="row stretch" fxLayout.xs="column">

                            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                                <ejs-richtexteditor #tituloRte formControlName="Titulo" [toolbarSettings]='tituloTools'
                                    (imageUploading)="tituloImageUploading($event)" (imageUploadSuccess)="tituloImageUploadSuccess($event)">
                                </ejs-richtexteditor>
                            </div>

                        </div>

                    </mat-expansion-panel>

                    <br/>

                    <!--Sección Descripción-->
                    <mat-expansion-panel [expanded]="true" hideToggle="true">

                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon style="margin-right: 5px;">edit_note</mat-icon> <p style="margin-top: 3px;">Cuerpo de la Publicación</p>
                            </mat-panel-title>
                            <mat-panel-description>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div fxLayout="row stretch" fxLayout.xs="column">

                            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                                <ejs-richtexteditor #descripcionRte formControlName="Descripcion" [toolbarSettings]='tools' [insertImageSettings]='insertImageSettings' 
                                    (imageUploading)="imageUploading($event)" (imageUploadSuccess)="imageUploadSuccess($event)">
                                </ejs-richtexteditor>
                            </div>

                        </div>

                    </mat-expansion-panel>

                    <br/>

                    <!--Sección Adjuntos-->
                    <mat-expansion-panel [expanded]="true" hideToggle="true">

                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon style="margin-right: 5px;">attach_file</mat-icon> Adjuntos
                            </mat-panel-title>
                            <mat-panel-description>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div fxLayout="row stretch" fxLayout.xs="column">

                            <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;" *ngIf="item.Adjuntos != null && item.Adjuntos.length > 0">
                                <mat-nav-list>
                                    <mat-list-item *ngFor="let file of item.Adjuntos" style="background-color: lightgray; margin: 5px 0px;border-radius: 10px;">
                                        <a matLine href="{{file.UrlDocumento}}" target="_blank">{{file.NombreDocumento}}</a>
                                        <button mat-icon-button (click)="onFileAttachedDelete(file)" title="Eliminar adjunto">
                                            <i class="fa fa-trash fa-1x"></i>
                                        </button>
                                    </mat-list-item>
                                </mat-nav-list>
                            </div>

                            <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;">
                                <button mat-icon-button matSuffix (click)="adjuntoInput.click()" [disabled]="isFileAttaching"><mat-icon style="margin-right: 5px;">attach_file</mat-icon> Agregar adjunto</button>
                                <input hidden (change)="onNewFileAttach($event)" #adjuntoInput type="file" multiple>
                                <mat-label *ngIf="isFileAttaching"><br/><i class="fa fa-spinner fa-spin"></i> Subiendo archivo...</mat-label>
                            </div>
                        </div>

                    </mat-expansion-panel>

                </form>

            </ng-container>

            <!--No puede editar-->
            <ng-container *ngIf="!canEdit && !canAdd">

                <!--Info general READONLY-->
                <mat-expansion-panel [expanded]="true">

                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon style="margin-top: -3px; margin-right: 5px;">settings</mat-icon> Datos Generales
                        </mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                    </mat-expansion-panel-header>

                    <div fxLayout="row stretch" class="zb-readonly">
                        <!--Carga de imágen-->
                        <div fxLayout="column" fxLayout.xs="column">
                            <div fxFlex=100 fxFlex.xs=100 class="flex-item" fxlayoutAlign="center" *ngIf="!imagenPortadaImageChanged()">
                                <a target="_blank" href="{{item?.ImagenPortadaUrl}}">
                                <img src="{{item?.ImagenPortadaUrl}}" style="height: 100px; width: 100px; border-radius: 100%;">
                                </a>
                            </div>
                            <div fxFlex=100 fxFlex.xs=100 class="flex-item" fxlayoutAlign="center" *ngIf="imagenPortadaImageChanged()">
                                <img src="{{imagenPortadaImageBase64}}"
                                style="height: 100px; width: 100px; border-radius: 100%; margin-bottom: 10px;">
                            </div>
                        </div>

                        <!--Edificio/Comunidad READONLY-->
                        <div fxLayout="column" fxLayout.xs="column" fxLayoutAlign="end">
                            <div fxFlex=40 fxFlex.xs=100 class="flex-item">
                                <mat-label><b>{{'Comunidad' | translate}}</b>: {{item.ComunidadNombre}}</mat-label> 
                            </div>
                        </div>

                    </div>

                </mat-expansion-panel>

                <br/>

                <!--Titulo y cuerpo de la publicación READONLY-->
                <!--Sección Título-->
                <mat-expansion-panel [expanded]="true" hideToggle="true">

                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon style="margin-right: 5px;">title</mat-icon> <p style="margin-top: 3px;">Título</p>
                        </mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                    </mat-expansion-panel-header>

                    <div fxLayout="row stretch" fxLayout.xs="column">

                        <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                            <div [innerHTML]="TituloHtml"></div>
                        </div>

                    </div>

                </mat-expansion-panel>

                <br/>

                <!--Sección Descripción-->
                <mat-expansion-panel [expanded]="true" hideToggle="true">

                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon style="margin-right: 5px;">edit_note</mat-icon> <p style="margin-top: 3px;">Cuerpo de la Publicación</p>
                        </mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                    </mat-expansion-panel-header>

                    <div fxLayout="row stretch" fxLayout.xs="column">

                        <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                            <div [innerHTML]="DescripcionHtml"></div>
                        </div>

                    </div>

                </mat-expansion-panel>

                <br/>

                <!--Adjuntos READONY-->
                <mat-expansion-panel [expanded]="true">

                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon style="margin-top: -3px;">attach_file</mat-icon> Adjuntos
                        </mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                    </mat-expansion-panel-header>

                    <div fxLayout="row stretch" fxLayout.xs="column">

                        <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;" *ngIf="isAttachmentSearching">
                        <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
                        </div>
                        <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;" *ngIf="!isAttachmentSearching">
                        <mat-nav-list>
                        <mat-list-item *ngFor="let file of item.Adjuntos" style="background-color: lightgray; margin: 5px 0px;border-radius: 10px;">
                            <a matLine href="{{file.UrlDocumento}}" target="_blank">{{file.NombreDocumento}}</a>
                        </mat-list-item>
                        </mat-nav-list>
                        </div>
                    </div>

                </mat-expansion-panel>

            </ng-container>

        </div>

    </mat-card-content>

    <mat-card-actions style="margin-bottom: 20px;">
        <div fxLayout="row stretch" fxLayout.xs="column">
            <button mat-raised-button (click)="onGuardar()" *ngIf="canEdit || canAdd" [disabled]="isProcessing()" color="primary" class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar'}}</button>
            <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">{{canEdit || canAdd ? 'Cancelar' : 'Cerrar'}}</button>
            <button mat-raised-button (click)="onDelete()" [disabled]="isProcessing()" *ngIf="canDelete && item?.Id != 0" color="accent" class="zb-button">{{isDeleting ? 'Eliminando...' : 'Eliminar'}}</button>
        </div>
    </mat-card-actions>

</mat-card>